export default "__VITE_ASSET__BA4VFIj7__"